import React from 'react';
import Portfolio from './components/Portfolio';
import { Analytics } from '@vercel/analytics/react';

function App() {
    return (
        <div className="App">
            <Portfolio />
            <Analytics />
        </div>
    );
}

export default App;